import { default as classnames, default as cn } from 'classnames';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ImageViewer from 'react-simple-image-viewer';
import { actionChangeWbProduct } from '../../../../../actions/wb';
import MarketWbApi from '../../../../../API/market/wb-api';
import { Column, Row } from '../../../../../components/Basic/Blocks';
import { Link } from '../../../../../components/Basic/Elements';
import { EditInput, Input } from '../../../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../../../components/Basic/Table';
import { H2, Text, TextGrey } from '../../../../../components/Basic/WrapsStyle';
import ProviderList from '../../../../../components/Common/Input/ProviderList';
import CommissionNdsBlock from '../../../../../components/Markets/Blocks/CommissionNdsBlock';
import { GO_TO_WB } from '../../../../../components/Markets/Blocks/Table/Line';
import { MARKETS_MAP } from '../../../../../constans';
import { formFullDate, numberWithSpaces } from '../../../../../utils';
import { calcWbProfit, calcWbSPP } from '../../../../../utils/wb';
import IncreasedCommissionTimerBlock from '../IncreasedCommissionTimerBlock';
import styles from './styles.module.scss';

const width = ['150px', '400px', '130px', '140px', '151px', '180px', '120px', '80px'];

const SKLAD_NAME_ZONE = {
  1168404: 'Екб',
  1184250: 'Екб',
  1184251: 'Екб',
  1184253: 'Екб',
  1184254: 'Екб',
  1184256: 'Екб',
  1184255: 'Екб',

  50: 'Мск Юг',
  20778: 'Мск Юг',
  46868: 'Мск Юг',
  75019: 'Мск Юг',
  77507: 'Мск Юг',
  738903: 'Мск Юг',
  738910: 'Мск Юг',

  1426758: 'Мск Восток',
  1426768: 'Мск Восток',
  1426772: 'Мск Восток',
  1426774: 'Мск Восток',
  1426778: 'Мск Восток',
  1426784: 'Мск Восток',
  1426781: 'Мск Восток',

  1426756: 'Мск Север',
  1426761: 'Мск Север',
  1426770: 'Мск Север',
  1426775: 'Мск Север',
  1426776: 'Мск Север',
  1426783: 'Мск Север',
  1426780: 'Мск Север',


  1531262: 'Мск Тверь',
  1531263: 'Мск Тверь',
  1531264: 'Мск Тверь',
  1531265: 'Мск Тверь',
  1531266: 'Мск Тверь',
  1531269: 'Мск Тверь',
  1531267: 'Мск Тверь',


  1531317: 'Мск Тула',
  1531318: 'Мск Тула',
  1531319: 'Мск Тула',
  1531320: 'Мск Тула',
  1531321: 'Мск Тула',
  1531323: 'Мск Тула',
  1531322: 'Мск Тула',

  1709933: 'Мск Истра',
  1426761: 'Мск Истра',
  1426770: 'Мск Истра',
  1709937: 'Мск Истра',
  1426776: 'Мск Истра',
  1426783: 'Мск Истра',
  1426780: 'Мск Истра',

};
const STATUSES_MAP = {
  new: 'Ожидает отгрузки', //сборочное задание в работе
  waiting: 'Ожидает отгрузки', //сборочное задание в работе
  sorted: 'Отсортировано', // сборочное задание отсортировано
  defect: 'Обнаружен брак',
  ready_for_pickup: 'Прибыл на ПВЗ',
  sold: 'Продано', // сборочное задание получено покупателем
  canceled: 'Отмена wb', // отмена сборочного задания
  canceled_by_client: 'Отмена клиентом', // отмена сборочного задания покупателем
};
const WbTableOrders = ({ skladName,  postings = [], map = {}, shop, ...props }) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [images, setImages] = useState([]);
  const [status, setStatus] = useState({});

  const [calculation, setCalculation] = useState({ all: 0, allCom: 0, allProfit: 0, allPurchase: 0, marginnality: 0 });

  const user = useSelector((store) => store.user);
  const dispatch = useDispatch();

  const onChangeProduct = async (offer_id, shop, key, value) => {
    console.log(offer_id, key, value);
    let setCard = (card) => {
      dispatch(actionChangeWbProduct(card));

      //setCards({ ...cards, byId: { ...cards.byId, [offer_id]: card } });
    };
    if (key === 'stock') {
      return await MarketWbApi.changeStock({ data: { shop, offer_id, value: parseInt(value), skladName } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'price' || key === 'discount') {
      return await MarketWbApi.changePrice({
        data: { shop: MARKETS_MAP[shop], offer_id, field: key, value: parseInt(value) },
      })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'percent' || key === 'min_rub') {
      return await MarketWbApi.changeMarginality({
        data: { shop: MARKETS_MAP[shop], offer_id, field: key, value: parseInt(value) },
      })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'stopbrand') {
      return await MarketWbApi.changeStopBrand({ data: { shop: MARKETS_MAP[shop], offerIds: [offer_id], value } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    return await MarketWbApi.changeCard({ data: { shop: MARKETS_MAP[shop], offer_id, field: key, value } })
      .then((r) => {
        setCard(r.card);
      })
      .catch((e) => console.log(e));
  };

  const shipmentOrders = async () => { };

  const openImageViewer = (images) => {
    setImages(images);
    setIsViewerOpen(true);
  };

  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  useEffect(() => {
    const res = postings.reduce(
      ({ all, allCom, allProfit, allPurchase }, order) => {
        const mapByShop = map[order.shop] || {};
        let loaded = !!mapByShop[order.offer_id];
        const info = { ...mapByShop[order.offer_id] } || {};
        const quantity = (mapByShop[order.offer_id] || {}).quantity || 1;
        const sum = order.prices?.price || Math.ceil((mapByShop[order.offer_id] || {}).prices?.price); //* quantity;
        const com = order.commission?.common?.rub; //* quantity;
        const profit = order.profit.rub; // * quantity

        /*   com = calcWbCommission(info, shop).all; //!* quantity;
           profit = calcWbProfit(info, shop); // * quantity
           purchase = info.purchase * quantity;
   */

        let purchase = 0;
        if (loaded) {
          purchase = info.purchase * quantity;
        }
        const oneOrder = { sum, com, profit, purchase };
        return {
          all: all + oneOrder.sum,
          allCom: allCom + oneOrder.com,
          allProfit: allProfit + oneOrder.profit,
          allPurchase: allPurchase + oneOrder.purchase,
        };
      },
      { all: 0, allCom: 0, allProfit: 0, allPurchase: 0 },
    );

    setCalculation({ ...res, marginnality: Math.ceil((res.allProfit * 100) / res.allPurchase) });
  }, [postings, map]);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  // useEffect(() => {
  //   /*  const ids = postings.map((item) => item.order_id);
  //   if (ids.length > 0) {
  //     wbOrdersStatuses(market, ids).then((data) => {
  //       setStatus(data);
  //     });
  //   }*/
  // }, [postings]);

  return (
    <>
      <Table styles={styles.ozon_table}>
        <TableHeader whiteHeader={true} styles={styles.table_line}>
          <HeaderTitle width={'50px'} />
          <HeaderTitle width={'90px'} centerText>
            Площадка
          </HeaderTitle>
          <HeaderTitle width={'70px'} noBorder />
          <HeaderTitle width={width[0]}>Номер заказа</HeaderTitle>
          <HeaderTitle width={width[3]}>Зона отгрузки</HeaderTitle>
          <HeaderTitle width={width[1]}>Позиции в заказе</HeaderTitle>
          <HeaderTitle width={width[6]} centerText>Артикул поставщика</HeaderTitle>
          <HeaderTitle width={width[2]}> Wb_Id</HeaderTitle>
          <HeaderTitle width={width[4]} centerText>
            Статус
          </HeaderTitle>
          {isOwner && (
            <>
              <HeaderTitle width={width[3]} centerText>
                Цена продажи
              </HeaderTitle>
              <HeaderTitle width={width[3]} centerText>
                Цена закупки
              </HeaderTitle>
            </>
          )}
          <HeaderTitle width={width[4]}>Прибыль/комиссия</HeaderTitle>
          <HeaderTitle width={width[3]} centerText>
            Цена до скидки, скидка
          </HeaderTitle>
          <HeaderTitle width={width[5]} centerText>
            Поставщик
          </HeaderTitle>

          <HeaderTitle width={width[6]} centerText>
            Количество в заказе
          </HeaderTitle>
          <HeaderTitle width={width[7]} centerText style={{ fontSize: '9px' }}>
            Цена до скидки
          </HeaderTitle>
          <HeaderTitle width={width[7]} centerText>
            Остаток
          </HeaderTitle>
          <HeaderTitle width={width[7]} centerText>
            Остаток на складе
          </HeaderTitle>
          <HeaderTitle width={width[6]} centerText>
            Время на доставку
          </HeaderTitle>
          <HeaderTitle width={width[6]} centerText>
            Статус клиента
          </HeaderTitle>
        </TableHeader>
        {postings.map((order, key) => {
          const mapByShop = map[order.shop] || {};
          const info = { ...mapByShop[order.offer_id] } || { loaded: false };

          let loaded = !!mapByShop[order.offer_id];
          const old_price = (mapByShop[order.offer_id] || {}).prices?.old_price;
          const sale_price = order.salePrice || Math.ceil((mapByShop[order.offer_id] || {}).prices?.price);

          const status_order = order.wbStatus; //status[order.order_id] ? status[order.order_id].status : null;

          const discount = (mapByShop[order.offer_id] || {}).discount?.percent;

          const profit = loaded ? calcWbProfit(info, shop) : 0;
          const spp = calcWbSPP(sale_price, order.cost);

          return (
            <TableLine
              key={order.order_id}
              styles={cn(
                discount === 'Возврат' && styles.red_line,
                order.userStatus === 'Доставлен' && styles.green_line,
                spp < -19 && styles.red_line_error,
              )}
            >
              <TableCell width="50px">{key + 1}</TableCell>
              <TableCell width={'90px'}>
                <div className={styles.wrapper}>{order.shop}</div>
              </TableCell>
              <TableCell width={'70px'}>
                <div className={styles.wrapper}>
                  <img
                    onClick={() => openImageViewer(info.images ? info.images : [])}
                    className={styles.preview}
                    src={info.images ? info.images[0] : undefined}
                  />
                </div>
              </TableCell>
              <TableCell width={width[0]}>
                <div className={styles.blue_text}>{order.order_id} </div>
                <TextGrey style={{ width: '100%', fontSize: 14 }}>{formFullDate(order.date_created)}</TextGrey>
              </TableCell>
              <TableCell width={width[3]}>{SKLAD_NAME_ZONE[order.warehouse_id || '']}</TableCell>

              <TableCell width={width[1]}>
                <div className={styles.div_line_images}>
                  <div className={styles.name}>
                    {loaded ? (
                      <EditInput name={info.name} onChange={(v) => onChangeProduct(info.offer_id, 'name', v)} />
                    ) : (
                      ''
                    )}
                  </div>
                  <TextGrey fontSize={14}>{info.offer_id || ''}</TextGrey>
                </div>
              </TableCell>
              <TableCell width={width[6]}>
                <div className={styles.div_line}>
                  <Input
                    disabled={true}
                    value={info.provider_artnumber}
                    onBlur={(v) => onChangeProduct(info.offer_id, 'provider_artnumber', v)}
                    center
                  />
                </div>
              </TableCell>
              <TableCell width={width[2]}>
                <Column className={styles.div_line}>
                  <Text className={loaded ? styles.green_text : styles.red_text} fontSize={12}>
                    {order.barcode}
                  </Text>
                  <Text fontWeight={500} fontSize={16} lineHeight="25px">
                    <Link
                      blue={true}
                      href={GO_TO_WB(info.nmID)}
                      style={{ width: '100%', fontSize: '14px' }}
                      target="_blank"
                    >
                      {info.nmID}
                    </Link>
                  </Text>
                </Column>
              </TableCell>

              <TableCell width={width[4]} center>
                {status_order && (
                  <div
                    className={cn(
                      styles.status,
                      status_order === 'ready_for_pickup' && styles.pickup,
                      status_order === 'waiting' && styles.waiting,
                      status_order === 'new' && styles.waiting,
                      status_order === 'defect' && styles.defect,
                      status_order === 'sold' && styles.sold,
                      status_order === 'sorted' && styles.sorted,
                      status_order === 'canceled' && styles.canceled,
                      status_order === 'canceled_by_client' && styles.canceled_by_client,
                    )}
                  >
                    {STATUSES_MAP[status_order]}
                  </div>
                )}
              </TableCell>

              {isOwner && (
                <>
                  <TableCell width={width[3]} center>
                    <div className={cn(styles.div_line, styles.div_price, order.cost !== sale_price && styles.sale)}>
                      <Row>
                        <Text fontSize={16} fontWeight={600}>
                          {sale_price}
                        </Text>{' '}
                        / {Math.ceil(order.cost)} {order.currencyCode}{' '}
                        {(spp > 0 || spp < 0) && <Text fontSize={12}>({spp} %)</Text>}
                      </Row>
                    </div>
                  </TableCell>
                  <TableCell width={width[3]}>
                    <Input value={info.purchase} onBlur={(v) => onChangeProduct(info.offer_id, 'purchase', v)} center />
                  </TableCell>
                </>
              )}
              <TableCell width={width[4]}>
                {isOwner ? (
                  <Column>
                    <div className={styles.div_commission}>
                      {loaded && (
                        <>
                          <Text className={classnames(styles.block_mar, order.profit?.is_minus && styles.red_text)}>
                            {order.profit?.percent ? Math.ceil(order.profit?.percent) : '-'} %
                          </Text>
                          <div className={styles.block_commission}>
                            <Text
                              fontWeight={600}
                              className={order.profit?.is_minus ? styles.red_text : styles.green_text}
                            >
                              {order.profit?.percent ? numberWithSpaces(Math.ceil(order.profit?.rub)) : '-'}
                            </Text>
                            <CommissionNdsBlock card={{ ...mapByShop[order.offer_id], ...order }} market={'WB'} />
                          </div>
                        </>
                      )}
                    </div>
                  </Column>
                ) : (
                  <Column style={{ alignItems: 'center' }}>
                    {loaded && (
                      <Text
                        className={profit < 0 ? styles.red_text : styles.green_text}
                        style={{ textAlign: 'center' }}
                      >
                        {profit < 0 ? `В минус на ${profit}` : 'ок'}
                      </Text>
                    )}
                  </Column>
                )}
              </TableCell>
              <TableCell width={width[3]} center>
                <div className={cn(styles.div_line, styles.div_price, order.cost !== sale_price && styles.sale)}>
                  <Row>
                    <Text fontSize={14}>
                      {old_price} {discount > 0 && `(-${discount}%)`}
                    </Text>
                  </Row>
                </div>
              </TableCell>
              <TableCell width={width[5]}>
                <Column style={{ alignItems: 'center' }}>
                  <div className={styles.div_line}>
                    <ProviderList
                      selectProviderId={info.provider_id}
                      disabled={true}
                      onSelect={(v) => onChangeProduct(info.offer_id, 'provider_id', v.id)}
                    />
                  </div>
                </Column>
              </TableCell>


              <TableCell width={width[6]}>
                <div className={styles.div_line}>
                  <Input value={info.quantity} onBlur={(v) => onChangeProduct(info.offer_id, 'quantity', v)} center />
                </div>
              </TableCell>

              <TableCell width={width[7]} center>
                <Text className={styles.div_line}>{sale_price}</Text>
              </TableCell>
              <TableCell width={width[7]}>
                <div className={styles.div_line}>
                  <Input
                    value={info.stock?.[skladName]?.common}
                    onBlur={(v) => onChangeProduct(info.offer_id, 'stock', v)}
                    center
                  />
                </div>
              </TableCell>
              <TableCell width={width[7]}>
                <div className={styles.div_line}>
                  <Input value={info.stock?.[skladName]?.warehouse} readOnly center />
                </div>
              </TableCell>
              <TableCell width={width[6]} center>
                <IncreasedCommissionTimerBlock date={order.date_created} order_id={order.order_id} />
              </TableCell>
              <TableCell width={width[6]} center>
                <Text style={{ textAlign: 'center' }}> {order.userStatus}</Text>
              </TableCell>
            </TableLine>
          );
        })}
      </Table>

      {calculation && (user.role === 'owner' || user.role === 'admin') && (
        <div style={{ marginTop: '10px' }}>
          <H2>Заказов на сумму: {numberWithSpaces(calculation.all.toFixed(0))} ₽</H2>
          <H2>Комиссия: {numberWithSpaces(calculation.allCom.toFixed(0))} ₽</H2>
          <H2>Закупка: {numberWithSpaces(calculation.allPurchase.toFixed(0))} ₽</H2>

          <H2>Прибыль: {numberWithSpaces(calculation.allProfit.toFixed(0))} ₽</H2>
          <H2>Маржинальность: ~ {numberWithSpaces(calculation.marginnality.toFixed(0))} %</H2>
        </div>
      )}
      {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
    </>
  );
};

export default WbTableOrders;
